const setTitle = (title) => {
    title = title ? `${title} - ` : '';
    document.title = `${title}Großtagespflegestelle / Kindertagespflege in Swisttal Heimerzheim - Das Entdeckerhäuschen`;
};

export default setTitle;
